module.exports = __webpack_public_path__ + "static/media/Tola Sylvan.bf6510a9.jpg";